module.exports = __webpack_public_path__ + "img/mindful_days_90--active.904845f4.svg";